import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateSubject($id: String!, $data: updateSubjectInput!) {
    updateSubject(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateSubjectRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateSubjectInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'subject/update_subject',
  async (
  params: {id: String;data: TYPES.UpdateSubjectInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateSubject;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateSubjectSlice = createSlice({
  name: 'update_subject',
  initialState: initialState,
  reducers: {
    updateSubjectClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateSubjectRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(updateSubjectRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(updateSubjectRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateSubjectClear } = updateSubjectSlice.actions;

export const updateSubject = createSelector(
  (state: RootState) => state.subject.updateSubject.result,
  (state: RootState) => state.subject.updateSubject.error,
  (state: RootState) => state.subject.updateSubject.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateSubjectSlice.reducer;